// JS for your graphic
import pym from "pym.js";
import * as d3 from "d3";
import emissions from "../data/data.csv"

const draw = async() => {

  /*
  Statistically insignificant:
    donated: -2
    mulched: -94
    composted: -234
  */

  // 

  const emissionsDataCSV = await d3.csv(emissions)
  const emissionsLabels = {"recycled": -17451, "landfilled": 4771};

  // Chart dimensions:

  let figureWidth = 500;
  if (figureWidth > window.innerWidth) {
    figureWidth = d3.select("figure").node().clientWidth;
  }

  if (figureWidth > window.innerWidth - 200) {
    figureWidth = window.innerWidth;
  }

  const figureHeight = 500;
  const margin = { "top": 10, "bottom": 100, "left": 40, "right": 20 }
  
  // Scales:
  /* This scale produces negative output for negatve input */

  // let yAxisScale = d3.scaleLinear()
  //   .domain([emissions_data["recycled"], emissions_data["landfilled"]])
  //   .range([figureHeight, 0]);


  const yAxis = d3.scaleLinear()
                .domain([emissionsLabels.recycled, emissionsLabels.landfilled*1.25])
                .range([figureHeight, 0]);

  
  /*
  * We need a different scale for drawing the y-axis. It needs
  * a reversed range, and a larger domain to accomodate negative values.
  */
  // let yAxisScale = d3.scaleLinear()
  //                 .domain([emissions_data["recycled"], emissions_data["landfilled"]])
  //                 .range([figureHeight - yScale(emissions_data["recycled"]), 0]);


  const xScale = d3.scaleBand().range([margin.left, figureWidth - margin.right]);

  // Create labels:

  const xLabels = ["Recycled", "Landfilled"];
  xScale.domain(xLabels).padding(0.3);

  // Draw canvas:
  const figure = d3.select("figure").append("svg")
    .attr("width", figureWidth).attr("height", figureHeight);

  figure.append("g")
    .attr("transform", `translate(${margin.left}, 0)`)
    .call(d3.axisLeft(yAxis).tickFormat((d) => d).ticks(15));

  // step 5: draw data
  figure.selectAll("rect").data(emissionsDataCSV)
    .enter()
    .append("rect")
    .attr("y", (d) => 
       yAxis(Math.max(0, d.value))
    )
    .attr("x", (d) => xScale(d.key))
    .attr("width", xScale.bandwidth())
    .attr("height", (d) => (Math.abs(yAxis(d.value) - yAxis(0))))
    .attr("fill", (d) => 
               { 
                 if (d.value > 0) 
                 {
                   return "rgb(165,42,42)";
                 } 
                 return "rgb(3, 192, 60)";
               });

  // Draw labels
  figure.append("g")
    /*
    This is where the x-axis is placed (the translation is the 
    placement coordinate.
    */
    .attr("transform", `translate(0, ${yAxis(0)})`)
    .call(d3.axisBottom(xScale).tickSize(0))
    .selectAll("text")
    .classed("text-style", true)
    .attr("text-anchor", "end")
    .attr("transform", "translate(24, -130)")

};

window.onresize = () => { };

window.onload = () => {
  const pymChild = new pym.Child({ polling: 500 });
  pymChild.sendHeight();
  draw();
};
